module.exports = __webpack_public_path__ + "static/media/WL_ICON.db7568f9.png";